import { render, staticRenderFns } from "./set-attribute.vue?vue&type=template&id=a859859a&scoped=true&"
import script from "./set-attribute.vue?vue&type=script&lang=js&"
export * from "./set-attribute.vue?vue&type=script&lang=js&"
import style0 from "./set-attribute.vue?vue&type=style&index=0&id=a859859a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a859859a",
  null
  
)

export default component.exports